module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "alertmodal",
    attrs: {
      "name": "alertmodal",
      "pivotY": 0.3,
      "reset": true,
      "height": "auto",
      "width": "50%"
    },
    on: {
      "before-open": _vm.beforeOpen,
      "closed": _vm.onClosed
    }
  }, [_c('div', {
    staticClass: "modal-block",
    class: _vm.params.type
  }, [(_vm.title) ? _c('div', {
    staticClass: "modal-content-header"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "message"
  }, [_vm._v("\n                " + _vm._s(_vm.params.message) + "\n            ")]), _vm._v(" "), (_vm.params.details) ? _c('div', {
    staticClass: "details-block"
  }, [_c('div', {
    staticClass: "details-button right-align"
  }, [_c('a', {
    on: {
      "click": _vm.toggleDetails
    }
  }, [_vm._v("\n                        Details\n                        "), _c('i', {
    staticClass: "fa",
    class: {
      'fa-chevron-up': _vm.isDetailsOpen, 'fa-chevron-down': !_vm.isDetailsOpen
    }
  })])]), _vm._v(" "), (_vm.isDetailsOpen) ? _c('div', {
    staticClass: "details"
  }, [_vm._v("\n                    " + _vm._s(_vm.params.details) + "\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons-block center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": _vm.modalClose
    }
  }, [_vm._v(_vm._s(_vm.params.dismissTitle))]), _vm._v(" "), (_vm.params.isCanRetry) ? _c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": _vm.retry
    }
  }, [_vm._v(_vm._s(_vm.params.retryTitle))]) : _vm._e()])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-788e9811", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-788e9811"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications/Alert.vue
// module id = 488
// module chunks = 1